interface UserCardProps {
  initials: string;
  name: string;
  role: string;
}

export function UserCard({ initials, name, role }: UserCardProps) {
  return (
    <div className="flex items-center gap-3 p-3 rounded-xl bg-sc-glass backdrop-blur-[12px] border border-sc-glass-border cursor-pointer hover:bg-sc-surface-hover transition-all">
      <div className="w-9 h-9 rounded-[10px] bg-gradient-to-br from-[#3cb34a] to-sc-navy flex items-center justify-center text-xs font-bold text-white shrink-0">
        {initials}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-xs font-semibold truncate">{name}</div>
        <div className="text-[10px] text-sc-text-muted truncate">{role}</div>
      </div>
    </div>
  );
}
